import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppConstants } from '../../app-constants';
import { SharedService } from '../../services/shared.service';

export const authGuard: CanActivateFn = (route, state) => {
   const router = inject(Router);
     const sharedService=inject(SharedService)
  const isLoggedIn = (): boolean => {
    const isAuthenticated = sharedService.getSession(AppConstants.LocalStorage.IsLoggedIn);;
    console.log('isAuthenticated:', isAuthenticated); // Debug
    return isAuthenticated
  };

console.log(isLoggedIn(),'isLoggedIn()')
  if (isLoggedIn()) {
    console.log("isLoggedIn inside")
    return true;
  } else {
    router.navigate([AppConstants.RoutingPaths.login]);
    return false;
  }
};
